export const kpiData = [
  {name: 'ConvertibleRatioScore', translationKey: 'component.iso.kpis.convertibleratio'},
  {name: 'ClientRetentionScore', translationKey: 'component.iso.kpis.clientretention'},
  {name: 'LeadCleanupQualityScore', translationKey: 'component.iso.kpis.leadcleanupquality'},
  {name: 'ClaimRatioScore', translationKey: 'component.iso.kpis.claimratio'}
];
